<template>
  <v-app>
    <component :is="layout">
      <router-view />
    </component>
    <v-overlay absolute :value="loading">
      <v-progress-circular indeterminate size="64" />
    </v-overlay>
  </v-app>
</template>

<script>
import { mapActions } from 'vuex'
import Api from './model/api'
const DEFAULT_LAYOUT = 'empty'
// объявляем переменную глобально
let myBody = null

export default {
  computed: {
    layout () {
      return (this.$route.meta.layout || DEFAULT_LAYOUT) + '-layout'
    },
    loading () {
      return this.$store.state.app.loading
    }
  },
  watch: {
    // проверяем по роуту и добавляем класс (к body)
    '$route' () {
      if (this.$route.path.indexOf('/map') !== -1) {
        myBody.classList.add('map-page')
      }
    }
  },
  created () {
    this.checkUser()
    this.setTransactions()
    // присваиваем body к переменному myBody
    myBody = document.getElementsByTagName('body')[0]
  },
  methods: {
    ...mapActions(['checkUser']),
    logout () {
      this.$store.dispatch('logout').then(() => {
        this.$router.push('/login')
      })
    },
    async setTransactions () {
      await Api.getTranslations().then((response) => {
        this.$i18n.setLocaleMessage('ru', response.data.ru)
        this.$i18n.setLocaleMessage('kg', response.data.kg)
        this.$i18n.setLocaleMessage('en', response.data.en)
      })
    }
  }
}
</script>

<style>
  @import 'assets/fonts.css';
  @import 'assets/style.css';
  @import 'assets/mobile.css';
</style>
